<template>
  <div class="benefits-page">
    <!-- Navigation Bar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top">
      <div class="container">
        <a class="navbar-brand d-flex align-items-center" href="#home">
          <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" height="50" class="me-3">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">

          <ul class="navbar-nav ms-auto align-items-center">
            <li class="nav-item">
              <a class="nav-link" href="javascript: void(0);" @click="goToPage('/')">Home</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="javascript: void(0);" @click="goToPage('about')">About</a>
            </li>
            <li class="nav-item d-none">
              <a class="nav-link" href="#how-it-works">How It Works</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#benefits">Benefits</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#services">Health Services</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#enrollment">Enrollment</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#facilities">Health Facilities</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#faqs">FAQs</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#contact">Contact</a>
            </li>

            <li class="nav-item dropdown ms-3">
              <button class="btn btn-primary dropdown-toggle" type="button"
                      id="loginDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bx bx-user me-2"></i>Login
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="loginDropdown">
                <li>
                  <a class="dropdown-item" @click="goToMemberLogin">
                    <i class="bx bx-user-circle me-2"></i>Member Portal
                  </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                  <a class="dropdown-item" @click="goToStaffLogin">
                    <i class="bx bx-briefcase me-2"></i>Staff Login
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Page Header -->
    <section class="page-header">
      <div class="header-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
      </div>
      <div class="container">
        <div class="row align-items-center min-vh-50 py-5">
          <div class="col-lg-7 text-white">
            <nav aria-label="breadcrumb" class="mb-4">
              <ol class="breadcrumb breadcrumb-light">
                <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Benefits</li>
              </ol>
            </nav>
            <h1 class="display-3 fw-bold mb-4 animate-on-scroll text-white">
              PONA HEALTH-X Benefits
            </h1>
            <p class="lead mb-4 animate-on-scroll">
              Discover the comprehensive benefits of Community-Based Health Insurance.
              From financial protection to quality healthcare access, PONA HEALTH-X provides
              complete coverage for you and your family.
            </p>
            <div class="header-stats d-flex flex-wrap gap-4 animate-on-scroll">
              <div class="header-stat">
                <div class="stat-icon"><i class="bx bx-shield-check"></i></div>
                <div class="stat-info">
                  <span class="stat-number">100%</span>
                  <span class="stat-label">Coverage</span>
                </div>
              </div>
              <div class="header-stat">
                <div class="stat-icon"><i class="bx bx-heart"></i></div>
                <div class="stat-info">
                  <span class="stat-number">15M+</span>
                  <span class="stat-label">Protected</span>
                </div>
              </div>
              <div class="header-stat">
                <div class="stat-icon"><i class="bx bx-happy-heart-eyes"></i></div>
                <div class="stat-info">
                  <span class="stat-number">85%</span>
                  <span class="stat-label">Satisfaction</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 d-none d-lg-block animate-on-scroll">
            <div class="header-illustration">
              <div class="illustration-card card-1">
                <i class="bx bx-check-shield"></i>
                <span>Protected</span>
              </div>
              <div class="illustration-card card-2">
                <i class="bx bx-wallet"></i>
                <span>Affordable</span>
              </div>
              <div class="illustration-card card-3">
                <i class="bx bx-group"></i>
                <span>Family</span>
              </div>
              <div class="illustration-main">
                <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=400"
                     alt="Healthcare Benefits"
                     class="img-fluid rounded-4">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Why Choose PONA HEALTH-X Section -->
    <section class="py-5 bg-white">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-6 mb-5 mb-lg-0 animate-on-scroll">
            <div class="why-choose-image">
              <img src="https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=600"
                   alt="Healthcare Protection"
                   class="img-fluid rounded-4 main-img">
              <div class="why-badge">
                <div class="badge-content">
                  <span class="badge-number">7+</span>
                  <span class="badge-text">Years of Healthcare Excellence</span>
                </div>
              </div>
              <div class="floating-benefit">
                <i class="bx bx-check-circle text-success"></i>
                <span>No Waiting Period</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6 animate-on-scroll">
            <div class="section-label">
              <span class="label-icon"><i class="bx bx-question-mark"></i></span>
              <span class="label-text">Why PONA HEALTH-X?</span>
            </div>
            <h2 class="display-5 fw-bold mb-4">
              Why Choose
              <span class="text-gradient">Community-Based Health Insurance?</span>
            </h2>
            <p class="lead text-muted mb-4">
              PONA HEALTH-X is designed to protect families from the financial burden of
              healthcare costs while ensuring access to quality medical services.
            </p>

            <div class="why-list">
              <div class="why-item" v-for="(item, index) in whyChoose" :key="index">
                <div class="why-number">{{ String(index + 1).padStart(2, '0') }}</div>
                <div class="why-content">
                  <h6 class="fw-bold mb-1">{{ item.title }}</h6>
                  <p class="text-muted small mb-0">{{ item.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Main Benefits Section -->
    <section class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-gift"></i></span>
            <span class="label-text">Member Benefits</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Comprehensive PONA HEALTH-X Benefits</h2>
          <p class="lead text-muted">Everything you and your family need for complete health protection</p>
        </div>

        <div class="benefits-grid">
          <div class="benefit-card-large animate-on-scroll"
               v-for="(benefit, index) in mainBenefits"
               :key="index"
               :class="'benefit-' + benefit.color">
            <div class="benefit-number">{{ String(index + 1).padStart(2, '0') }}</div>
            <div class="benefit-icon-wrapper">
              <i :class="benefit.icon"></i>
            </div>
            <div class="benefit-content">
              <h4 class="fw-bold mb-3">{{ benefit.title }}</h4>
              <p class="mb-4">{{ benefit.description }}</p>
              <ul class="benefit-features">
                <li v-for="feature in benefit.features" :key="feature">
                  <i class="bx bx-check-circle"></i>
                  <span>{{ feature }}</span>
                </li>
              </ul>
            </div>
            <div class="benefit-decoration"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- Coverage Comparison Section -->
    <section class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-transfer"></i></span>
            <span class="label-text">Compare</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">With vs Without PONA HEALTH-X</h2>
          <p class="lead text-muted">See the difference PONA HEALTH-X makes in protecting your family</p>
        </div>

        <div class="row">
          <div class="col-lg-10 mx-auto">
            <div class="comparison-container animate-on-scroll">
              <div class="comparison-card without">
                <div class="comparison-header">
                  <i class="bx bx-x-circle"></i>
                  <h4>Without PONA HEALTH-X</h4>
                </div>
                <ul class="comparison-list">
                  <li v-for="item in withoutPonaHealth" :key="item">
                    <i class="bx bx-x text-danger"></i>
                    <span>{{ item }}</span>
                  </li>
                </ul>
                <div class="comparison-cost">
                  <span class="cost-label">Average Annual Healthcare Cost</span>
                  <span class="cost-value text-danger">KES 150,000+</span>
                </div>
              </div>

              <div class="comparison-divider">
                <div class="divider-circle">
                  <i class="bx bx-transfer-alt"></i>
                </div>
              </div>

              <div class="comparison-card with">
                <div class="comparison-header">
                  <i class="bx bx-check-circle"></i>
                  <h4>With PONA HEALTH-X</h4>
                </div>
                <ul class="comparison-list">
                  <li v-for="item in withPonaHealth" :key="item">
                    <i class="bx bx-check text-success"></i>
                    <span>{{ item }}</span>
                  </li>
                </ul>
                <div class="comparison-cost">
                  <span class="cost-label">Annual Premium (Medium Plan)</span>
                  <span class="cost-value text-success">KES 15,000</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Savings Calculator -->
        <div class="row mt-5">
          <div class="col-lg-8 mx-auto animate-on-scroll">
            <div class="savings-card">
              <div class="savings-icon">
                <i class="bx bx-calculator"></i>
              </div>
              <div class="savings-content">
                <h4 class="fw-bold mb-2">Potential Annual Savings</h4>
                <p class="text-muted mb-3">By joining PONA HEALTH-X, families can save significantly on healthcare costs</p>
                <div class="savings-amount">
                  <span class="amount-label">Save up to</span>
                  <span class="amount-value">KES 135,000+</span>
                  <span class="amount-label">per year</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Coverage Details Section -->
    <section class="py-5 bg-gradient-primary text-white">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label-light justify-content-center">
            <span class="label-icon"><i class="bx bx-list-check"></i></span>
            <span class="label-text">What's Covered</span>
          </div>
          <h2 class="display-5 fw-bold mb-3 text-white">Comprehensive Coverage Details</h2>
          <p class="lead opacity-75">All the healthcare services covered under PONA HEALTH-X membership</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-4 col-md-6 animate-on-scroll" v-for="coverage in coverageDetails" :key="coverage.title">
            <div class="coverage-card h-100">
              <div class="coverage-icon" :class="'bg-' + coverage.color">
                <i :class="coverage.icon"></i>
              </div>
              <h5 class="fw-bold mb-3 text-white">{{ coverage.title }}</h5>
              <ul class="coverage-list">
                <li v-for="item in coverage.items" :key="item">
                  <i class="bx bx-check"></i>{{ item }}
                </li>
              </ul>
              <div class="coverage-tag">{{ coverage.tag }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Premium Plans Section -->
    <section class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-money"></i></span>
            <span class="label-text">Pricing</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Affordable Premium Plans</h2>
          <p class="lead text-muted">Choose the plan that fits your family's needs and budget</p>
        </div>

        <div class="row g-4 justify-content-center">
          <div class="col-lg-4 col-md-6 animate-on-scroll" v-for="(plan) in premiumPlans" :key="plan.name">
            <div class="plan-card h-100" :class="{ 'featured': plan.featured }">
              <div class="plan-badge" v-if="plan.featured">Most Popular</div>
              <div class="plan-header">
                <div class="plan-icon" :class="plan.colorClass">
                  <i :class="plan.icon"></i>
                </div>
                <h4 class="plan-name">{{ plan.name }}</h4>
                <p class="plan-subtitle">{{ plan.subtitle }}</p>
              </div>
              <div class="plan-price">
                <span class="currency">KES</span>
                <span class="amount">{{ plan.price }}</span>
                <span class="period">/year</span>
              </div>
              <ul class="plan-features">
                <li v-for="feature in plan.features" :key="feature" :class="{ 'disabled': feature.startsWith('✗') }">
                  <i :class="feature.startsWith('✗') ? 'bx bx-x text-muted' : 'bx bx-check text-success'"></i>
                  <span>{{ feature.replace('✗ ', '') }}</span>
                </li>
              </ul>
              <div class="plan-footer">
                <router-link to="/enrollment" class="btn" :class="plan.featured ? 'btn-primary' : 'btn-outline-primary'">
                  <i class="bx bx-user-plus me-2"></i>Enroll Now
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- Payment Methods -->
        <div class="row mt-5">
          <div class="col-lg-10 mx-auto">
            <div class="payment-methods-card animate-on-scroll">
              <h5 class="text-center fw-bold mb-4">Accepted Payment Methods</h5>
              <div class="payment-methods">
                <div class="payment-method" v-for="method in paymentMethods" :key="method.name">
                  <div class="method-icon">
                    <i :class="method.icon"></i>
                  </div>
                  <span class="method-name">{{ method.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Who Can Benefit Section -->
    <section class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-user-check"></i></span>
            <span class="label-text">Eligibility</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Who Can Benefit from PONA HEALTH-X?</h2>
          <p class="lead text-muted">PONA HEALTH-X is designed for informal sector workers and rural communities</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-3 col-md-6 animate-on-scroll" v-for="group in eligibleGroups" :key="group.title">
            <div class="eligible-card h-100">
              <div class="eligible-icon">
                <i :class="group.icon"></i>
              </div>
              <h5 class="fw-bold mb-3">{{ group.title }}</h5>
              <p class="text-muted mb-3">{{ group.description }}</p>
              <ul class="eligible-list">
                <li v-for="item in group.examples" :key="item">{{ item }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonials Section -->
    <section class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-message-square-dots"></i></span>
            <span class="label-text">Testimonials</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">What Our Members Say</h2>
          <p class="lead text-muted">Real stories from PONA HEALTH-X members</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-4 animate-on-scroll" v-for="testimonial in testimonials" :key="testimonial.name">
            <div class="testimonial-card h-100">
              <div class="testimonial-quote">
                <i class="bx bxs-quote-alt-left"></i>
              </div>
              <p class="testimonial-text">{{ testimonial.text }}</p>
              <div class="testimonial-author">
                <div class="author-avatar">
                  <img :src="testimonial.avatar" :alt="testimonial.name">
                </div>
                <div class="author-info">
                  <h6 class="fw-bold mb-0">{{ testimonial.name }}</h6>
                  <p class="text-muted small mb-0">{{ testimonial.location }}</p>
                </div>
              </div>
              <div class="testimonial-rating">
                <i class="bx bxs-star" v-for="n in 5" :key="n"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ Section -->
    <section class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-help-circle"></i></span>
            <span class="label-text">FAQs</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Frequently Asked Questions</h2>
          <p class="lead text-muted">Common questions about PONA HEALTH-X benefits</p>
        </div>

        <div class="row">
          <div class="col-lg-10 mx-auto">
            <div class="accordion accordion-flush" id="benefitsFAQ">
              <div class="accordion-item animate-on-scroll" v-for="(faq, index) in faqs" :key="index">
                <h2 class="accordion-header" :id="'heading' + index">
                  <button class="accordion-button" :class="{ collapsed: index !== 0 }"
                          type="button" data-bs-toggle="collapse"
                          :data-bs-target="'#collapse' + index">
                    <i class="bx bx-help-circle me-3 text-primary"></i>
                    {{ faq.question }}
                  </button>
                </h2>
                <div :id="'collapse' + index"
                     class="accordion-collapse collapse"
                     :class="{ show: index === 0 }"
                     data-bs-parent="#benefitsFAQ">
                  <div class="accordion-body">
                    {{ faq.answer }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="py-5 bg-gradient-primary text-white">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-8 animate-on-scroll">
            <h2 class="display-5 fw-bold mb-3 text-white">Ready to Get Protected?</h2>
            <p class="lead mb-4 mb-lg-0 opacity-75">
              Join over 15 million members who trust PONA HEALTH-X for their healthcare needs.
              Enroll today and start enjoying comprehensive health coverage for your family.
            </p>
          </div>
          <div class="col-lg-4 text-lg-end animate-on-scroll">
            <router-link to="/enrollment" class="btn btn-light btn-lg mb-3 me-3">
              <i class="bx bx-user-plus me-2"></i>Enroll Now
            </router-link>
            <router-link to="/contact" class="btn btn-outline-light btn-lg mb-3">
              <i class="bx bx-phone me-2"></i>Contact Us
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-dark text-white py-5">
      <div class="container">
        <div class="row g-4">
          <div class="col-lg-4">
            <div class="d-flex align-items-center mb-4">
              <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" height="40" class="me-3" style="background: white; padding: 5px; border-radius: 8px;">
              <div>
                <div class="fw-bold">PONA HEALTH-X</div>
                <div class="small text-white-50">Community-Based Health Insurance</div>
              </div>
            </div>
            <p class="text-white-50 mb-4">
              Working towards universal health coverage through community-based health insurance.
            </p>
            <div class="social-links">
              <a href="#" class="social-link"><i class="bx bxl-facebook-circle"></i></a>
              <a href="#" class="social-link"><i class="bx bxl-twitter"></i></a>
              <a href="#" class="social-link"><i class="bx bxl-linkedin-square"></i></a>
              <a href="#" class="social-link"><i class="bx bxl-youtube"></i></a>
            </div>
          </div>
          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Quick Links</h6>
            <ul class="footer-links">
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/about">About Us</router-link></li>
              <li><router-link to="/benefits">Benefits</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Resources</h6>
            <ul class="footer-links">
              <li><a href="#">FAQs</a></li>
              <li><a href="#">Downloads</a></li>
              <li><router-link to="/enrollment">Enrollment</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>
            </ul>
          </div>
          <div class="col-lg-4">
            <h6 class="fw-bold mb-3 text-white">Contact Us</h6>
            <ul class="footer-contact">
              <li><i class="bx bx-map me-2"></i>Headquarters</li>
              <li><i class="bx bx-phone me-2"></i>Call: +254 700 000 000</li>
              <li><i class="bx bx-envelope me-2"></i>info@ponahealth.com</li>
            </ul>
          </div>
        </div>
        <hr class="my-4 opacity-25">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-start">
            <p class="mb-0 text-white-50 small">
              © 2025 PONA HEALTH-X. All rights reserved.
            </p>
          </div>
          <div class="col-md-6 text-center text-md-end">
            <a href="#" class="text-white-50 small text-decoration-none me-3">Privacy Policy</a>
            <a href="#" class="text-white-50 small text-decoration-none">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>

    <!-- Scroll to Top -->
    <button class="scroll-top-btn" @click="scrollToTop" v-show="showScrollTop">
      <i class="bx bx-chevron-up"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PonaHealthBenefitsPage',

  data() {
    return {
      showScrollTop: false,

      whyChoose: [
        {
          title: 'Financial Protection',
          description: 'Shield your family from unexpected medical expenses and avoid debt'
        },
        {
          title: 'Quality Healthcare Access',
          description: 'Visit any of 3,500+ contracted health facilities nationwide'
        },
        {
          title: 'Community Solidarity',
          description: 'Join millions pooling resources to help each other in times of need'
        },
        {
          title: 'Government Support',
          description: 'Subsidized premiums for vulnerable households ensure no one is left behind'
        }
      ],

      mainBenefits: [
        {
          icon: 'bx bx-shield-check',
          title: 'Financial Protection',
          description: 'PONA HEALTH-X protects your family from the devastating financial impact of unexpected medical expenses, preventing debt and poverty due to healthcare costs.',
          color: 'blue',
          features: [
            'No out-of-pocket payments at point of care',
            'Protection from catastrophic health expenditures',
            'Predictable annual premium costs',
            'Government subsidies for poorest households'
          ]
        },
        {
          icon: 'bx bx-heart',
          title: 'Comprehensive Healthcare',
          description: 'Access a wide range of medical services including outpatient care, hospitalization, emergency treatment, and essential medications.',
          color: 'red',
          features: [
            'Outpatient consultations and treatments',
            'Inpatient hospital care',
            'Emergency medical services',
            'Essential medicines and prescriptions'
          ]
        },
        {
          icon: 'bx bx-group',
          title: 'Family Coverage',
          description: 'One membership covers your entire household, including spouse and children, ensuring everyone in your family is protected.',
          color: 'green',
          features: [
            'Spouse coverage included',
            'Children under 18 covered',
            'Add additional dependents',
            'Single premium for whole family'
          ]
        },
        {
          icon: 'bx bx-time-five',
          title: 'Immediate Coverage',
          description: 'Start accessing healthcare services immediately after enrollment and premium payment - no waiting periods for most services.',
          color: 'orange',
          features: [
            'No waiting period for emergencies',
            'Immediate outpatient access',
            'Quick card issuance',
            'Digital card available instantly'
          ]
        },
        {
          icon: 'bx bx-map',
          title: 'Wide Network Access',
          description: 'Receive care at over 3,500 contracted health facilities, including health posts, centers, and hospitals.',
          color: 'purple',
          features: [
            '16,000+ health posts',
            '3,500+ health centers',
            '311+ hospitals',
            'Coverage in all regions'
          ]
        },
        {
          icon: 'bx bx-mobile-alt',
          title: 'Digital Services',
          description: 'Manage your insurance online through our member portal. View coverage, track payments, and access your digital membership card.',
          color: 'teal',
          features: [
            'Online member portal',
            'Digital membership card',
            'Payment history tracking',
            'Beneficiary management'
          ]
        }
      ],

      withoutPonaHealth: [
        'Pay full cost for every doctor visit',
        'Risk of medical debt and bankruptcy',
        'May delay or skip needed care due to cost',
        'No protection for unexpected emergencies',
        'Entire savings can be wiped out by illness',
        'Must pay upfront before receiving care',
        'No negotiated rates with providers'
      ],

      withPonaHealth: [
        'Access care with minimal or no payment',
        'Financial protection for your family',
        'Seek care when you need it',
        'Emergency coverage 24/7',
        'Predictable annual cost',
        'Show card and receive care',
        'Discounted rates at all facilities'
      ],

      coverageDetails: [
        {
          icon: 'bx bx-clinic',
          title: 'Outpatient Care',
          color: 'primary',
          tag: 'Unlimited Visits',
          items: ['Doctor consultations', 'Physical examinations', 'Minor procedures', 'Prescription medications', 'Preventive care', 'Health screenings']
        },
        {
          icon: 'bx bx-bed',
          title: 'Inpatient Care',
          color: 'success',
          tag: 'Full Coverage',
          items: ['Hospital admission', 'Room and board', 'Nursing care', 'Surgical procedures', 'ICU when needed', 'Recovery care']
        },
        {
          icon: 'bx bx-heart',
          title: 'Maternity Services',
          color: 'danger',
          tag: 'Complete Care',
          items: ['Antenatal checkups', 'Delivery services', 'C-section if needed', 'Postnatal care', 'Newborn care', 'Family planning']
        },
        {
          icon: 'bx bx-first-aid',
          title: 'Emergency Care',
          color: 'warning',
          tag: '24/7 Access',
          items: ['Emergency treatment', 'Trauma care', 'Ambulance services', 'Urgent procedures', 'Stabilization', 'Emergency surgery']
        },
        {
          icon: 'bx bx-test-tube',
          title: 'Laboratory Services',
          color: 'info',
          tag: 'Comprehensive',
          items: ['Blood tests', 'Urine analysis', 'Microscopy', 'Pathology', 'Diagnostic tests', 'Regular monitoring']
        },
        {
          icon: 'bx bx-capsule',
          title: 'Pharmacy Benefits',
          color: 'purple',
          tag: 'Essential Meds',
          items: ['Prescribed medicines', 'Generic drugs', 'Antibiotics', 'Chronic disease meds', 'Pain relief', 'Supplements']
        }
      ],

      premiumPlans: [
        {
          name: 'Lower Plan',
          subtitle: 'For Indigent Households',
          icon: 'bx bx-shield',
          price: '0',
          colorClass: 'bg-success',
          featured: false,
          features: [
            'Full government subsidy',
            'All essential services covered',
            'Family coverage included',
            'No waiting period',
            'Health post access',
            'Health center access',
            '✗ Premium hospital services'
          ]
        },
        {
          name: 'Medium Plan',
          subtitle: 'Most Popular Choice',
          icon: 'bx bx-shield-check',
          price: '15,000',
          colorClass: 'bg-primary',
          featured: true,
          features: [
            'Partial government subsidy',
            'Comprehensive coverage',
            'Full family coverage',
            'No waiting period',
            'All health facilities',
            'Hospital access',
            'Extended services'
          ]
        },
        {
          name: 'Upper Plan',
          subtitle: 'Maximum Protection',
          icon: 'bx bx-shield-x',
          price: '19,500',
          colorClass: 'bg-warning',
          featured: false,
          features: [
            'Full premium coverage',
            'Comprehensive coverage',
            'Full family coverage',
            'No waiting period',
            'All health facilities',
            'Referral hospitals',
            'Specialist consultations'
          ]
        }
      ],

      paymentMethods: [
        { name: 'Cash', icon: 'bx bx-money' },
        { name: 'Bank Transfer', icon: 'bx bx-bank' },
        { name: 'Mobile Money', icon: 'bx bx-mobile' },
        { name: 'M-Pesa', icon: 'bx bx-wallet' },
        { name: 'Card Payment', icon: 'bx bx-credit-card' }
      ],

      eligibleGroups: [
        {
          icon: 'bx bx-leaf',
          title: 'Farmers',
          description: 'Agricultural workers and their families',
          examples: ['Crop farmers', 'Livestock keepers', 'Mixed farmers', 'Agricultural laborers']
        },
        {
          icon: 'bx bx-store',
          title: 'Self-Employed',
          description: 'Small business owners and traders',
          examples: ['Shop owners', 'Market vendors', 'Artisans', 'Service providers']
        },
        {
          icon: 'bx bx-hard-hat',
          title: 'Daily Laborers',
          description: 'Workers in informal employment',
          examples: ['Construction workers', 'Domestic workers', 'Casual laborers', 'Transport workers']
        },
        {
          icon: 'bx bx-home-heart',
          title: 'Rural Households',
          description: 'Families in rural communities',
          examples: ['Village residents', 'Remote communities', 'Pastoral areas', 'Agricultural zones']
        }
      ],

      testimonials: [
        {
          text: 'PONA HEALTH-X saved our family when my father needed emergency surgery. Without it, we would have lost everything we had. Now I tell everyone in my village to join.',
          name: 'Mary Wanjiku',
          location: 'Central Region',
          avatar: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=100'
        },
        {
          text: 'As a farmer, I never thought I could afford health insurance. PONA HEALTH-X premiums are so affordable, and now my whole family can see doctors without worry.',
          name: 'John Kamau',
          location: 'Western Region',
          avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100'
        },
        {
          text: 'My wife had a safe delivery at the health center thanks to PONA HEALTH-X. The care was excellent and we didn\'t pay a single shilling. This is what everyone deserves.',
          name: 'Peter Ochieng',
          location: 'Eastern Region',
          avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100'
        }
      ],

      faqs: [
        {
          question: 'When do my PONA HEALTH-X benefits start?',
          answer: 'Your PONA HEALTH-X benefits start immediately after enrollment and premium payment. There is no waiting period for most services, including emergency care, outpatient visits, and essential treatments. You can visit any contracted health facility right away.'
        },
        {
          question: 'Are pre-existing conditions covered?',
          answer: 'Yes, PONA HEALTH-X covers pre-existing conditions. Unlike private insurance, PONA HEALTH-X does not exclude members based on their current health status. Whether you have diabetes, hypertension, or other chronic conditions, you are eligible for coverage.'
        },
        {
          question: 'Can I choose my own doctor or hospital?',
          answer: 'You can receive care at any PONA HEALTH-X-contracted health facility in your area. For primary care, you should visit your designated health center first. Referrals to higher-level facilities and specialists are provided when medically necessary.'
        },
        {
          question: 'What happens if I need care outside my district?',
          answer: 'PONA HEALTH-X coverage is generally portable. If you need emergency care while traveling, you can receive treatment at any contracted facility. For planned care outside your district, you may need a referral from your primary facility.'
        },
        {
          question: 'How do I add a new family member?',
          answer: 'New family members can be added during your annual renewal period. For newborns, you can add them immediately after birth by visiting your local health office with the birth certificate. The newborn is covered from birth.'
        },
        {
          question: 'What services are NOT covered by PONA HEALTH-X?',
          answer: 'PONA HEALTH-X covers essential healthcare services. Services generally not covered include cosmetic procedures, treatments outside the country, experimental treatments, and services at non-contracted facilities. Traditional medicine may have limited coverage.'
        }
      ]
    };
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.observeElements();
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    observeElements() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      document.querySelectorAll('.animate-on-scroll').forEach(el => {
        observer.observe(el);
      });
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    handleScroll() {
      this.showScrollTop = window.pageYOffset > 300;
    },

    goToMemberLogin() {
      this.$router.push('/member-login');
    },
    goToPage(page) {
      this.$router.push(page);
    },


    goToStaffLogin() {
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
/* ========================================================================= */
/* BENEFITS PAGE - PONA HEALTH-X STYLES */
/* ========================================================================= */

.benefits-page {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  overflow-x: hidden;
  background: #fafbfc;
}

/* ========================================================================= */
/* NAVIGATION */
/* ========================================================================= */
.navbar {
  padding: 1rem 0;
  transition: all 0.4s ease;
  z-index: 1001;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
}

.brand-title {
  font-weight: 800;
  font-size: 1.1rem;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-subtitle {
  font-size: 0.75rem;
  color: #6c757d;
  font-weight: 600;
}

.nav-link {
  font-weight: 600;
  color: #495057 !important;
  transition: all 0.3s ease;
}

.nav-link:hover,
.nav-link.active {
  color: #2c5aa0 !important;
}

.dropdown-menu {
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  padding: 0.5rem;
}

.dropdown-item {
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
  font-weight: 500;
}

.dropdown-item:hover {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  transform: translateX(5px);
}

/* ========================================================================= */
/* PAGE HEADER */
/* ========================================================================= */
.page-header {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 50%, #4a90e2 100%);
  padding-top: 120px;
  padding-bottom: 60px;
  position: relative;
  overflow: hidden;
}

.header-shapes {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
}

.shape-1 {
  width: 400px;
  height: 400px;
  top: -100px;
  right: -100px;
  animation: float 8s ease-in-out infinite;
}

.shape-2 {
  width: 300px;
  height: 300px;
  bottom: -50px;
  left: 10%;
  animation: float 6s ease-in-out infinite reverse;
}

.shape-3 {
  width: 200px;
  height: 200px;
  top: 50%;
  left: 30%;
  animation: float 10s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-30px) rotate(5deg); }
}

.min-vh-50 {
  min-height: 50vh;
}

.breadcrumb-light {
  background: transparent;
  margin: 0;
  padding: 0;
}

.breadcrumb-light .breadcrumb-item a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb-light .breadcrumb-item a:hover {
  color: white;
}

.breadcrumb-light .breadcrumb-item.active {
  color: white;
}

.breadcrumb-light .breadcrumb-item + .breadcrumb-item::before {
  color: rgba(255, 255, 255, 0.5);
}

/* Header Stats */
.header-stats {
  margin-top: 2rem;
}

.header-stat {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 1rem 1.5rem;
  border-radius: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.stat-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
}

.stat-number {
  display: block;
  font-size: 1.5rem;
  font-weight: 900;
  color: white;
  line-height: 1;
}

.stat-label {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.8);
}

/* Header Illustration */
.header-illustration {
  position: relative;
  height: 400px;
}

.illustration-main {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.illustration-main img {
  width: 280px;
  height: 280px;
  object-fit: cover;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.illustration-card {
  position: absolute;
  background: white;
  padding: 1rem 1.5rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  z-index: 2;
  animation: cardFloat 4s ease-in-out infinite;
}

.illustration-card i {
  font-size: 1.5rem;
  color: #2c5aa0;
}

.illustration-card span {
  font-weight: 700;
  color: #1e3f70;
}

.illustration-card.card-1 {
  top: 20%;
  left: 0;
  animation-delay: 0s;
}

.illustration-card.card-2 {
  top: 60%;
  left: -10%;
  animation-delay: 1s;
}

.illustration-card.card-3 {
  top: 30%;
  right: 0;
  animation-delay: 2s;
}

@keyframes cardFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
}

/* ========================================================================= */
/* SECTION LABELS */
/* ========================================================================= */
.section-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.section-label-light {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.label-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: #2c5aa0;
}

.section-label-light .label-icon {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.label-text {
  font-weight: 700;
  font-size: 0.9rem;
  color: #2c5aa0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.section-label-light .label-text {
  color: rgba(255, 255, 255, 0.9);
}

.text-gradient {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ========================================================================= */
/* WHY CHOOSE SECTION */
/* ========================================================================= */
.why-choose-image {
  position: relative;
}

.main-img {
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  transition: all 0.4s ease;
}

.why-choose-image:hover .main-img {
  transform: scale(1.02);
}

.why-badge {
  position: absolute;
  bottom: -30px;
  right: 30px;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 15px 40px rgba(44, 90, 160, 0.4);
}

.badge-number {
  display: block;
  font-size: 2.5rem;
  font-weight: 900;
  line-height: 1;
}

.badge-text {
  font-size: 0.8rem;
  opacity: 0.9;
}

.floating-benefit {
  position: absolute;
  top: 30px;
  left: -20px;
  background: white;
  padding: 0.75rem 1.25rem;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  font-weight: 600;
  font-size: 0.9rem;
  animation: cardFloat 3s ease-in-out infinite;
}

.why-list {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-top: 2rem;
}

.why-item {
  display: flex;
  gap: 1.25rem;
  padding: 1.25rem;
  background: #f8f9fa;
  border-radius: 1rem;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.why-item:hover {
  background: #e3f2fd;
  border-left-color: #2c5aa0;
  transform: translateX(10px);
}

.why-number {
  font-size: 1.5rem;
  font-weight: 900;
  color: #2c5aa0;
  opacity: 0.3;
  line-height: 1;
}

/* ========================================================================= */
/* MAIN BENEFITS GRID */
/* ========================================================================= */
.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
}

.benefit-card-large {
  background: white;
  border-radius: 1.5rem;
  padding: 2.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  transition: all 0.4s ease;
}

.benefit-card-large:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.benefit-number {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  font-size: 4rem;
  font-weight: 900;
  opacity: 0.08;
  line-height: 1;
}

.benefit-icon-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-size: 2.5rem;
  color: white;
  transition: all 0.3s ease;
}

.benefit-card-large:hover .benefit-icon-wrapper {
  transform: scale(1.1) rotate(5deg);
}

.benefit-blue .benefit-icon-wrapper { background: linear-gradient(135deg, #2c5aa0, #4a90e2); }
.benefit-red .benefit-icon-wrapper { background: linear-gradient(135deg, #dc3545, #f1707a); }
.benefit-green .benefit-icon-wrapper { background: linear-gradient(135deg, #28a745, #5cb85c); }
.benefit-orange .benefit-icon-wrapper { background: linear-gradient(135deg, #fd7e14, #ffb347); }
.benefit-purple .benefit-icon-wrapper { background: linear-gradient(135deg, #6f42c1, #9d7bd1); }
.benefit-teal .benefit-icon-wrapper { background: linear-gradient(135deg, #20c997, #63e6be); }

.benefit-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.benefit-features li {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.benefit-features li:last-child {
  border-bottom: none;
}

.benefit-features li:hover {
  transform: translateX(10px);
}

.benefit-features li i {
  color: #28a745;
  font-size: 1.25rem;
}

.benefit-decoration {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 5px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.benefit-blue .benefit-decoration { background: linear-gradient(90deg, #2c5aa0, #4a90e2); }
.benefit-red .benefit-decoration { background: linear-gradient(90deg, #dc3545, #f1707a); }
.benefit-green .benefit-decoration { background: linear-gradient(90deg, #28a745, #5cb85c); }
.benefit-orange .benefit-decoration { background: linear-gradient(90deg, #fd7e14, #ffb347); }
.benefit-purple .benefit-decoration { background: linear-gradient(90deg, #6f42c1, #9d7bd1); }
.benefit-teal .benefit-decoration { background: linear-gradient(90deg, #20c997, #63e6be); }

.benefit-card-large:hover .benefit-decoration {
  opacity: 1;
}

/* ========================================================================= */
/* COMPARISON SECTION */
/* ========================================================================= */
.comparison-container {
  display: flex;
  gap: 0;
  background: white;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
}

.comparison-card {
  flex: 1;
  padding: 2.5rem;
}

.comparison-card.without {
  background: #fff5f5;
}

.comparison-card.with {
  background: #f0fff4;
}

.comparison-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.comparison-header i {
  font-size: 2.5rem;
}

.comparison-card.without .comparison-header i {
  color: #dc3545;
}

.comparison-card.with .comparison-header i {
  color: #28a745;
}

.comparison-header h4 {
  font-weight: 800;
  margin: 0;
}

.comparison-list {
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
}

.comparison-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 0;
  font-size: 0.95rem;
}

.comparison-list li i {
  font-size: 1.25rem;
  flex-shrink: 0;
  margin-top: 2px;
}

.comparison-cost {
  padding: 1.5rem;
  background: white;
  border-radius: 1rem;
  text-align: center;
}

.cost-label {
  display: block;
  font-size: 0.85rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
}

.cost-value {
  font-size: 1.75rem;
  font-weight: 900;
}

.comparison-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  background: white;
  position: relative;
}

.divider-circle {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #2c5aa0, #4a90e2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
  box-shadow: 0 4px 15px rgba(44, 90, 160, 0.3);
}

/* Savings Card */
.savings-card {
  display: flex;
  align-items: center;
  gap: 2rem;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  padding: 2.5rem;
  border-radius: 1.5rem;
  border: 3px solid #2c5aa0;
}

.savings-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #2c5aa0, #4a90e2);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  color: white;
  flex-shrink: 0;
}

.savings-amount {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin-top: 1rem;
}

.amount-label {
  font-size: 1rem;
  color: #6c757d;
}

.amount-value {
  font-size: 2.5rem;
  font-weight: 900;
  color: #28a745;
}

/* ========================================================================= */
/* COVERAGE DETAILS */
/* ========================================================================= */
.bg-gradient-primary {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 50%, #4a90e2 100%);
}

.coverage-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 1.5rem;
  border: 2px solid rgba(255, 255, 255, 0.15);
  transition: all 0.4s ease;
  position: relative;
}

.coverage-card:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-10px);
  border-color: rgba(255, 255, 255, 0.3);
}

.coverage-icon {
  width: 70px;
  height: 70px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-size: 2rem;
  color: white;
  transition: all 0.3s ease;
}

.coverage-card:hover .coverage-icon {
  transform: scale(1.1) rotate(5deg);
}

.bg-primary { background: linear-gradient(135deg, #2c5aa0, #4a90e2) !important; }
.bg-success { background: linear-gradient(135deg, #28a745, #5cb85c) !important; }
.bg-danger { background: linear-gradient(135deg, #dc3545, #f1707a) !important; }
.bg-warning { background: linear-gradient(135deg, #ffc107, #ffda6a) !important; }
.bg-info { background: linear-gradient(135deg, #17a2b8, #5bc0de) !important; }
.bg-purple { background: linear-gradient(135deg, #6f42c1, #9d7bd1) !important; }

.coverage-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.coverage-list li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.95rem;
}

.coverage-list li i {
  color: #4ade80;
}

.coverage-tag {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: rgba(255, 255, 255, 0.2);
  padding: 0.35rem 0.75rem;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 700;
  color: white;
}

/* ========================================================================= */
/* PREMIUM PLANS */
/* ========================================================================= */
.plan-card {
  background: white;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  border: 2px solid transparent;
  position: relative;
}

.plan-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.plan-card.featured {
  border-color: #2c5aa0;
  transform: scale(1.05);
}

.plan-card.featured:hover {
  transform: scale(1.05) translateY(-10px);
}

.plan-badge {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  text-align: center;
  padding: 0.5rem;
  font-weight: 700;
  font-size: 0.85rem;
}

.plan-header {
  padding: 2.5rem 2rem 1.5rem;
  text-align: center;
}

.plan-card.featured .plan-header {
  padding-top: 3.5rem;
}

.plan-icon {
  width: 70px;
  height: 70px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2rem;
  color: white;
}

.plan-name {
  font-weight: 800;
  margin-bottom: 0.5rem;
}

.plan-subtitle {
  color: #6c757d;
  font-size: 0.9rem;
}

.plan-price {
  text-align: center;
  padding: 1.5rem;
  background: #f8f9fa;
}

.plan-price .currency {
  font-size: 1.25rem;
  font-weight: 700;
  color: #6c757d;
}

.plan-price .amount {
  font-size: 3rem;
  font-weight: 900;
  color: #1e3f70;
  margin: 0 0.25rem;
}

.plan-price .period {
  font-size: 1rem;
  color: #6c757d;
}

.plan-features {
  list-style: none;
  padding: 2rem;
  margin: 0;
}

.plan-features li {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.plan-features li:last-child {
  border-bottom: none;
}

.plan-features li i {
  font-size: 1.25rem;
}

.plan-features li.disabled {
  opacity: 0.5;
}

.plan-footer {
  padding: 0 2rem 2rem;
}

.plan-footer .btn {
  width: 100%;
}

/* Payment Methods */
.payment-methods-card {
  background: white;
  padding: 2.5rem;
  border-radius: 1.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
}

.payment-methods {
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.payment-method {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 1.5rem;
  border-radius: 1rem;
  transition: all 0.3s ease;
}

.payment-method:hover {
  background: #f8f9fa;
  transform: translateY(-5px);
}

.method-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  color: #2c5aa0;
}

.method-name {
  font-weight: 600;
  font-size: 0.9rem;
}

/* ========================================================================= */
/* ELIGIBLE GROUPS */
/* ========================================================================= */
.eligible-card {
  background: white;
  padding: 2rem;
  border-radius: 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  text-align: center;
  border: 2px solid transparent;
}

.eligible-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(44, 90, 160, 0.15);
  border-color: #e3f2fd;
}

.eligible-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2.5rem;
  color: #2c5aa0;
  transition: all 0.3s ease;
}

.eligible-card:hover .eligible-icon {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  transform: scale(1.1);
}

.eligible-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.eligible-list li {
  padding: 0.5rem 0;
  padding-left: 1.5rem;
  position: relative;
  color: #6c757d;
  font-size: 0.9rem;
}

.eligible-list li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #2c5aa0;
  font-weight: bold;
}

/* ========================================================================= */
/* TESTIMONIALS */
/* ========================================================================= */
.testimonial-card {
  background: white;
  padding: 2rem;
  border-radius: 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  position: relative;
}

.testimonial-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(44, 90, 160, 0.15);
}

.testimonial-quote {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  font-size: 3rem;
  color: #e3f2fd;
  line-height: 1;
}

.testimonial-text {
  font-size: 1rem;
  line-height: 1.8;
  color: #495057;
  margin-bottom: 1.5rem;
  font-style: italic;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.author-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
}

.author-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.testimonial-rating {
  margin-top: 1rem;
}

.testimonial-rating i {
  color: #ffc107;
  font-size: 1rem;
}

/* ========================================================================= */
/* FAQ ACCORDION */
/* ========================================================================= */
.accordion-item {
  margin-bottom: 1rem;
  border: none;
  border-radius: 1rem !important;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.accordion-button {
  font-weight: 600;
  color: #1e3f70;
  background-color: white;
  padding: 1.25rem 1.5rem;
  font-size: 1rem;
}

.accordion-button:not(.collapsed) {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1e3f70;
  box-shadow: none;
}

.accordion-button:focus {
  box-shadow: none;
}

.accordion-body {
  padding: 1.5rem;
  line-height: 1.8;
  color: #495057;
}

/* ========================================================================= */
/* BUTTONS */
/* ========================================================================= */
.btn {
  padding: 0.875rem 2rem;
  border-radius: 0.75rem;
  font-weight: 700;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.btn-primary {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  border-color: transparent;
  color: white;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
}

.btn-outline-primary {
  color: #2c5aa0;
  border-color: #2c5aa0;
}

.btn-outline-primary:hover {
  background: #2c5aa0;
  color: white;
}

.btn-light {
  background: white;
  color: #2c5aa0;
}

.btn-outline-light {
  color: white;
  border-color: white;
}

.btn-outline-light:hover {
  background: white;
  color: #2c5aa0;
}

/* ========================================================================= */
/* FOOTER */
/* ========================================================================= */
footer {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-links a:hover {
  color: white;
  padding-left: 8px;
}

.footer-contact {
  list-style: none;
  padding: 0;
}

.footer-contact li {
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-links .social-link {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.social-links .social-link:hover {
  background: white;
  color: #2c5aa0;
  transform: translateY(-5px);
}

/* ========================================================================= */
/* SCROLL BUTTON */
/* ========================================================================= */
.scroll-top-btn {
  position: fixed;
  bottom: 35px;
  right: 35px;
  width: 55px;
  height: 55px;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.4);
  transition: all 0.3s ease;
  z-index: 1000;
  font-size: 1.8rem;
}

.scroll-top-btn:hover {
  transform: translateY(-8px) scale(1.1);
  box-shadow: 0 15px 40px rgba(44, 90, 160, 0.6);
}

/* ========================================================================= */
/* ANIMATIONS */
/* ========================================================================= */
.animate-on-scroll {
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.animate-on-scroll.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* ========================================================================= */
/* RESPONSIVE */
/* ========================================================================= */
@media (max-width: 992px) {
  .comparison-container {
    flex-direction: column;
  }

  .comparison-divider {
    width: 100%;
    height: 60px;
    justify-content: center;
  }

  .benefits-grid {
    grid-template-columns: 1fr;
  }

  .savings-card {
    flex-direction: column;
    text-align: center;
  }

  .header-illustration {
    display: none;
  }
}

@media (max-width: 768px) {
  .page-header {
    padding-top: 100px;
  }

  .page-header h1 {
    font-size: 2.5rem;
  }

  .header-stats {
    flex-direction: column;
  }

  .header-stat {
    width: 100%;
  }

  .why-badge {
    position: static;
    margin-top: 1.5rem;
    display: inline-block;
  }

  .floating-benefit {
    display: none;
  }

  .plan-card.featured {
    transform: none;
  }

  .plan-card.featured:hover {
    transform: translateY(-10px);
  }
}

/* ========================================================================= */
/* UTILITY */
/* ========================================================================= */
.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}
</style>